import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';
import { useDispatch } from 'react-redux';
import {
  useAppSelector,
  selectIsUploadFileToTeamsLoaded,
} from '../../slices/commonSelectors';
import { shareFileWithTeams } from 'actions/teamsActions';
import { useIcsFormPdfPreview } from 'components/IAP/context/IcsFormPdfPreviewContext';
import {
  ResponsibleRoleType,
  PlanningPhaseType,
} from './planningView/USCGPage';
import RoleTag from './planningView/widgets/RoleTag';
import { Accordion } from '../DesignSystems/Accordion/Accordion';
import { SharedIcon } from '../SharedIcon/SharedIcon';
import { FormExportButton } from 'components/IAP/FormExportButton';

type FormExportCardProps = {
  formName: string;
  label: string;
  description?: string;
  canShareWithTeams: boolean;
  imageData?: string | null;
  responsibleRoles?: ResponsibleRoleType[];
  planningPhases?: PlanningPhaseType[];
};

const FormExportCard: React.FC<FormExportCardProps> = ({
  formName,
  label,
  description,
  canShareWithTeams = false,
  imageData,
  responsibleRoles = [],
  planningPhases = [],
}) => {
  const dispatch = useDispatch();
  const isUploadFileToTeamsLoaded = useAppSelector(
    selectIsUploadFileToTeamsLoaded
  );
  const { exportAsForm } = useIcsFormPdfPreview();

  const handleExport = (format: 'pdf' | 'docx') => {
    void exportAsForm({ formname: formName, mapSketch: imageData, format });
  };

  return (
    <Accordion
      eventKey={formName}
      header={
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center flex-grow-1 gap-2">
            <SharedIcon iconName="description" size="sm" />
            <div className="flex-grow-1">
              <div className="fs-5">{label}</div>
              {description && (
                <div className="text-muted fs-6">{description}</div>
              )}
            </div>
          </div>
          {responsibleRoles.length > 0 && (
            <div>
              <RoleTag icsRoles={responsibleRoles} />
            </div>
          )}
        </div>
      }
    >
      <div className="p-3">
        {planningPhases.length > 0 && (
          <div className="mb-3">
            <RoleTag icsRoles={planningPhases} />
          </div>
        )}
        <div className="d-flex gap-2">
          {canShareWithTeams && (
            <StylishNewButton
              className="button--secondary"
              onClick={() =>
                dispatch(shareFileWithTeams({ formName: formName }))
              }
              disabled={!isUploadFileToTeamsLoaded}
            >
              Share
            </StylishNewButton>
          )}
          <FormExportButton
            formname={formName}
            onExport={handleExport}
            label="Preview"
          />
        </div>
      </div>
    </Accordion>
  );
};

export default FormExportCard;
